import {usePatchSaleVehicleMutation} from '@dms/api/vehicle';

import {Nullish} from 'shared/web';

interface PatchSaleFields {
  vehicleSourceCodeId: string | Nullish;
  salePresetId: string | Nullish;
  qualitySealKey: string | Nullish;
  warrantyProgramId: string | Nullish;
  warrantyDuration: number | Nullish;
}

export function usePatchSaleFields() {
  const [patchSaleVehicle, {isLoading: isPatchSaleVehicleLoading}] = usePatchSaleVehicleMutation();

  const patchSaleVehicleFields = async (vehicleId: string, fields: PatchSaleFields) => {
    // `undefined` means "the user did not touch this field", while `null` is an explicit clear that
    // must reach the backend — so this deliberately tests against undefined and not nullishness.
    const hasFieldToPatch = Object.values(fields).some((value) => value !== undefined);

    if (hasFieldToPatch) {
      await patchSaleVehicle({
        vehicleId,
        patchSaleVehicleRequestBody: {
          vehicleSourceCodeId: fields.vehicleSourceCodeId,
          salePresetId: fields.salePresetId,
          qualitySealKey: fields.qualitySealKey,
          warrantyProgramId: fields.warrantyProgramId,
          warrantyDuration: fields.warrantyDuration,
        },
      }).unwrap();
    }
  };

  return [
    patchSaleVehicleFields,
    {
      isLoading: isPatchSaleVehicleLoading,
    },
  ] as const;
}
